import { ProductItemPropTypes } from '@/components/Card/Product';
import { CountryCodes } from './lookup';
import { Store } from './stores';

export enum ORDER_STATUS_ENUMS {
  confirmed = 'order_confirmed',
  pending = 'pending',
  processing = 'processing',
  failed = 'failed',
  cancelled = 'cancelled',
  delivered = 'delivered',
  payment_recieved = 'payment_recieved',
}

export const USER_VISIBLE_ORDER_STATUSES = [
  ORDER_STATUS_ENUMS.pending,
  ORDER_STATUS_ENUMS.confirmed,
  ORDER_STATUS_ENUMS.failed,
];

export type OrderDetailProps = {
  id?: number;
  entity_id?: string;
  order_id?: string;
  increment_id?: string;
  store_id?: string;
  email: string;
  mobile: string;
  grand_total: number;
  status?: ORDER_STATUS_ENUMS;
  status_label?: string;
  created_at?: Date;
  label?: string;
  items?: ProductItemPropTypes[];
  order_items?: ProductItemPropTypes[];
  payment: Payment[];
  street?: string;
  city?: string;
  // postcode?: string;
  region?: string;
  country_code?: CountryCodes;
  delivery_date?: string;
  can_cancelled?: boolean;
  min_diff_ms?: number;
  customer_name?: string;
  history?: OrderHistory[];
  shipping_data?: any;
  billing_data?: any;
  shipping_method_code:
    | 'freeshipping_freeshipping'
    | 'bestway_bestway'
    | 'flatrate_flatrate';
  type?: string;
  data?: any;
  order_type?: 'event' | 'online';
  rzr_order_id?: string;
  shipping_method?:
    | 'freeshipping_freeshipping'
    | 'bestway_bestway'
    | 'flatrate_flatrate';
  show_retry_payment?: 'true' | 'false';
};

export type OrderHistory = {
  status: string;
  createdAt: string;
  selected: boolean;
  label: string;
  position: number;
};

export type Payment = {
  code: keyof typeof OrderSummeryBreakUpTitle;
  value: string;
  subtotal?: string;
  discount?: string;
  shipping?: string;
  tax?: string;
  grand_total?: string;
  payment_fee?: string;
};

export type FoodStore = {
  id: number;
  name: string;
  code: string;
  phone: string;
  region_id: number;
  // postcode: string;
  city: string;
  street_line1: string;
  street_line2: string;
  country_id: string;
  telephone: string;
  street: string[];
  region_code: string;
  region: string;
};

export enum OrderSummeryBreakUpTitle {
  'subtotal' = 'Order Value',
  'shipping' = 'Convenience & Handling Fee',
  'payment_fee' = 'Payment Collection Charges',
  'tax' = 'Tax',
  'discount' = 'Promotion Applied',
  'grand_total' = 'Grand Total',
  'packaging_charge' = 'Packaging Charge',
}

export enum CheckoutOrderSummeryBreakUpTitle {
  'subtotal' = 'Order Value',
  'payment_fee' = 'Payment Collection Charges',
  'tax' = 'Tax',
  'discount' = 'Promotion Applied',
  'grand_total' = 'Grand Total',
  'shipping' = 'Convenience & Handling Fee',
  'packaging_charge' = 'Packaging Charge',
}

export interface InStoreOrdersType {
  bill_no: string;
  status: string;
  reference_number: string;
  total: string;
  store_id: number;
  sales_outlet_id: string;
  customer_id: string;
  sales_customer_id: string;
  bill_date: Date;
  sales_customer_name: string;
  customer_mobile: string;
  identifier: string;
  items: Item[];
}

export interface InStoreOrderDetail extends InStoreOrdersType {
  store?: Store;
}

export interface Item {
  sku: number;
  product_name: string;
  product_id: string;
  item_id: string;
  offline_order_id: string;
  product_image: string;
  quantity: string;
  price: string;
  row_total: string;
  original_price: string;
}

export interface KSEventPropType {
  booked_on: string;
  event_end_date: string;
  event_start_date: string;
  image: string;
  increment_id: string;
  location: string;
  name: string;
  sku: string;
  status: string;
  total_qty: string;
  type: string;
}
